import emptyImage from "@/assets/emptyImage.svg";
import Checkbox from "@/common/elements/InputElements/CheckBox";
import TextField from "@/common/elements/InputElements/TextField";
import Modal from "@/common/elements/Modal";
import _ from "lodash";
import { v4 as uuidV4 } from "uuid";
import {
  forwardRef,
  Fragment,
  useEffect,
  useImperativeHandle,
  useState,
  useRef,
} from "react";
import { Divider, Form } from "antd";
import {
  FormContainer,
  InmateDetailsTableContainer,
  TableHeader,
} from "./styles";
import { labels } from "@/util/label";
import { ModalBody } from "@/common/elements/Modal/styles";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import {
  StyledGridCol,
  StyledGridRow,
  StyledInformationList,
  StyledModalContent,
  StyledTypographyText,
} from "@/common/styles";
import Select from "@/common/elements/InputElements/Select";
import {
  getOptionsFromRefList,
  hasCheckSecurity,
  isNonEmptyVariable,
} from "@/util/common_function";
import Button from "@/common/elements/Button";
import Table from "@/common/elements/Table";
import { BookingsSectionTitle } from "../BookingsDetails/styles";
import FileUploader from "../FileUploader";
import Alert from "@/common/elements/Alerts";
import Popconfirm from "@/common/elements/Popconfirm";
import CommonDatePicker from "@/common/elements/DatePicker";
import PropertyChainCustodyDetails from "./PropertyChainCustodyDetails";
// import PropertyChainCustodyForm from "./PropertyChainCustodyForm";
import CommonReportModal from "../CommonReport/CommonReportModal";
import api from "@/services/axios_custom";
import API_ENDPOINTS from "@/util/api";
import { PHOTOS_BASE_URL } from "@/util/api";
import dayjs from "dayjs";
import { Entity_types, Security_Types } from "@/util/permission_bits";
import { LABELS_CAPITAL } from "@/util/usePermissionMask";
import {
  MODULES_LIST_WITH_ID,
  SUB_MODULES_LIST_WITH_ID,
} from "@/util/common_variable";
import { useSelector } from "react-redux";

export const MODE = { NEW: "new", EDIT: "edit" };

const PropertyModal = forwardRef(
  ({
    property,
    show,
    handleCancel,
    handleSubmit,
    propertyItemFormRef,
    propertyPhotos,
    isEdit,
  }) => {
    console.log({ isEdit });
    const [form] = Form.useForm();
    const [imageForm] = Form.useForm();
    const [propertyItem, setPropertyItem] = useState(null);
    const [imgData, setImgData] = useState(null);
    const [formData, setFormData] = useState(null);
    const { bookingsFieldsEnabled } = useSelector(
      (state) => state?.bookings
    );
    // Removed single uploadedImagePath; we now use photoList.
    const [checkOutItemConfirm, setCheckOutItemConfirm] = useState(false);
    const [isClearForDisposal, setIsClearForDisposal] = useState(false);
    const [isDisposalCleared, setIsDisposalCleared] = useState(
      property?.inventoryItems?.[0]?.itemStatus === "Disposed"
    );
    const [isChainCustodyReport, setIsChainCustodyReport] = useState(false);
    const [showPhotoInformation, setShowPhotoInformation] = useState(false);
    const [custodyTransactions, setCustodyTransactions] = useState([]);
    const [checkoutText, setCheckoutText] = useState(""); // new state for popconfirm input
    const custodyDetailsRef = useRef(null); // ref to control custody modal

    const [itemStatus, setItemStatus] = useState(
      property?.inventoryItems?.[0]?.itemStatus || "Checked In"
    );
    const [checkedOutBy, setCheckedOutBy] = useState("");
    const [checkInItemConfirm, setCheckInItemConfirm] = useState(false);
    const [checkInText, setCheckInText] = useState("");

    // New state: list of photos, temporary file storage, selected and editing photo.
    const [photoList, setPhotoList] = useState([]);
    const [pendingFile, setPendingFile] = useState(null);
    const [selectedPhoto, setSelectedPhoto] = useState(null);
    const [editingPhoto, setEditingPhoto] = useState(null);
    const [isDisabled, setIsDisabled] = useState(false);
    const disposalType = Form.useWatch(
      ["inventoryItems", 0, "disposalType"],
      form
    );
    const fullSearch = useSelector(state => state.fullSearch);

    const clickPhotoInformation = () => {
      // When adding a new photo, clear any previous editing info.
      setEditingPhoto(null);
      imageForm.resetFields();
      setPendingFile(null);
      // Clear the FileUploader preview by forcing an empty string.
      setShowPhotoInformation(true);
    };

    const reportTableData = {
      headers: [
        { key: "id", text: "#" },
        { key: "dateAdded", text: "Date Added" },
        { key: "timeAdded", text: "Time Added" },
        { key: "enteredBy", text: "Entered By" },
        { key: "type", text: "Type" },
        { key: "custodyDetails", text: "Chain of Custody Details" },
      ],
      data: custodyTransactions.map((tx, index) => ({
        id: index + 1,
        dateAdded: tx.dateAdded,
        timeAdded: tx.timeAdded,
        enteredBy: tx.user,
        type: tx.transactionType,
        custodyDetails: tx.comments,
      })),
    };

    useEffect(() => {
      const updatedProperty = _.cloneDeep(property);
      const inventoryItem = updatedProperty?.inventoryItems?.[0];

      // Convert planned disposal date to a dayjs object if it exists
      if (inventoryItem) {
        if (inventoryItem?.plannedDisposalDate) {
          inventoryItem.plannedDisposalDate = dayjs(
            inventoryItem.plannedDisposalDate,
            "MM/DD/YYYY"
          );
        } else {
          inventoryItem.plannedDisposalDate = null;
        }
        if (inventoryItem?.disposalDate) {
          inventoryItem.disposalDate = dayjs(
            inventoryItem.disposalDate,
            "MM/DD/YYYY"
          );
        } else {
          inventoryItem.disposalDate = null;
        }
        setPropertyItem(updatedProperty);
        if (updatedProperty?.inventoryItemTransactions?.length > 0) {
          const lastTransaction =
            updatedProperty.inventoryItemTransactions[
              updatedProperty.inventoryItemTransactions.length - 1
            ];
        }
      }
      // If editing an existing property, initialize photoList from inventoryItems[0].propertyPhotos.
      if (
        property &&
        property.inventoryItems &&
        property.inventoryItems.length > 0 &&
        property.inventoryItems?.[0].propertyPhotos &&
        property.inventoryItems?.[0].propertyPhotos.length > 0
      ) {
        // Instead of taking only the first element's photos, combine photos from all elements.
        const allPhotos = property.inventoryItems[0].propertyPhotos.reduce(
          (acc, curr) => {
            if (curr.photos && Array.isArray(curr.photos)) {
              return acc.concat(curr.photos);
            }
            return acc;
          },
          []
        );
        setPhotoList(allPhotos);

        if (allPhotos.length > 0) {
          setImgData(allPhotos[0].fullSizePath);
        }
      }
      if (
        property &&
        property.inventoryItems &&
        property.inventoryItems.length > 0
      ) {
        // Check if the item was previously cleared for disposal
        const cleared = property.inventoryItems?.[0].clearedForDisposal;
        if (cleared) {
          setIsClearForDisposal(true);
        }
        const disposed = property.inventoryItems?.[0]?.disposalDate;
        if (disposed) {
          setIsDisposalCleared(true);
        }
      }
    }, [property]);

    useEffect(() => {
      if (propertyItem !== null) {
        form.setFieldsValue(propertyItem);
        form.setFieldValue(["inventoryItems", 0, "storageLocation1Id"], !fullSearch ? 50500006 : null);
      } else {
        form.setFieldValue(["inventoryItems", 0, "storageLocation1Id"], !fullSearch ? 50500006 : null);
        form.setFieldValue(["inventoryItems", 0, "itemStatus"], "Checked In");
      }
    }, [propertyItem]);

    useEffect(() => {
      imageForm.setFieldsValue(formData);
    }, [formData]);

    useEffect(() => {
      if (propertyItem !== null) {
        form.setFieldsValue(propertyItem);

        if (propertyItem.propertyPhotos?.length > 0) {
          const imagePath = propertyItem.propertyPhotos?.[0].imagePath;
          setImgData(imagePath);
        } else {
          setImgData(null);
        }
      } else {
        setImgData(null);
      }
    }, [propertyItem]);

    useImperativeHandle(propertyItemFormRef, () => ({
      form,
      imageForm,
      getFormValues: () => {
        const values = {
          ...form.getFieldsValue(),
          ...imageForm.getFieldsValue(),
        };
        // Regular expression to test if a string is a UUID.
        const uuidRegex =
          /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
        if (values.inventoryItems && values.inventoryItems?.[0]) {
          values.inventoryItems[0].propertyPhotos = photoList.map(
            (p, index) => {
              return {
                propertyPhotoId:
                  p.propertyPhotoId !== undefined ? p.propertyPhotoId : null,
                // If photoId exists and matches the UUID pattern, set it to null (new entry)
                photoId:
                  p.photoId && !uuidRegex.test(p.photoId) ? p.photoId : null,
                guak: null,
                photos: [
                  {
                    photoId:
                      p.photoId && !uuidRegex.test(p.photoId)
                        ? p.photoId
                        : null,
                    dateAdded: p.dateAdded,
                    timeAdded: p.timeAdded,
                    user: "System",
                    fullSizePath: p.fullSizePath,
                    thumbnailPath: p.thumbnailPath,
                    sequence: index + 1,
                    imageType: p.imageType,
                    lockToPassword: null,
                    affiliation: null,
                    description: p.description,
                    creatorStaffId: p.creatorStaffId,
                  },
                ],
                propertyId: p.propertyId !== undefined ? p.propertyId : null,
              };
            }
          );
        }

        // Start with the current custody transactions state mapped for the payload.
        let transactions =
          custodyTransactions.map((tx) => ({
            inventoryItemTransactionId: tx.inventoryItemTransactionId || null,
            dateAdded: tx.dateAdded || (!fullSearch ? dayjs().format("MM/DD/YYYY") : null),
            timeAdded: tx.timeAdded || (!fullSearch ? dayjs().format("HH:mm") : null),
            user: tx.user || "System",
            transactionType: tx.transactionType || "Initial Entry",
            comments: tx.comments || "",
            inventoryItemTransactionsExtras:
              tx.inventoryItemTransactionsExtras || [],
          })) || [];

        values.inventoryItemTransactions = transactions;
        // Format dates if they exist
        if (values?.inventoryItems?.[0]?.plannedDisposalDate) {
          values.inventoryItems[0].plannedDisposalDate = dayjs(
            values.inventoryItems[0].plannedDisposalDate
          ).format("MM/DD/YYYY");
        }
        if (values.inventoryItems[0]?.disposalDate) {
          values.inventoryItems[0].disposalDate = dayjs(
            values.inventoryItems[0].disposalDate
          ).format("MM/DD/YYYY");
        }
        // Helper: update custody transactions based on itemStatus
        const updateTransactionsForStatus = (vals) => {
          const status = itemStatus;
          let txs = vals.inventoryItemTransactions || [];
          switch (status) {
            case "Clear for Disposal": {
              // Only add if planned disposal date exists
              if (vals.inventoryItems[0]?.plannedDisposalDate) {
                let unpaired = false;
                txs.forEach((tx) => {
                  if (tx.transactionType === "Clear for Disposal") {
                    unpaired = true;
                  } else if (
                    tx.transactionType === "Revoke Clearance" &&
                    unpaired
                  ) {
                    unpaired = false;
                  }
                });

                if (!unpaired && vals.inventoryItems[0]?.plannedDisposalDate) {
                  // Retrieve the planned disposal date and authorized-by value from the form values
                  const plannedDate =
                    vals.inventoryItems[0].plannedDisposalDate;
                  const authBy =
                    vals.inventoryItems[0].disposalAuthorizedBy || "N/A";
                  const disposalType =
                    vals.inventoryItems[0].plannedDisposalType;
                  // Build the comment in the required format
                  const comment = `SCHEDULED FOR DISPOSAL (${disposalType}) ON ${plannedDate}, AUTHORIZED BY ${authBy}`;

                  const newTx = {
                    inventoryItemTransactionId: null,
                    dateAdded: !fullSearch ? dayjs().format("MM/DD/YYYY") : null,
                    timeAdded: !fullSearch ? dayjs().format("HH:mm") : null,
                    user: "System",
                    transactionType: "Clear for Disposal",
                    comments: comment,
                    inventoryItemTransactionsExtras: [],
                  };
                  txs = [...txs, newTx];
                }
              }
            }
            case "Disposed": {
              if (vals.inventoryItems[0]?.disposalDate) {
                // Check if a "Disposed" transaction already exists
                const disposalTxExists = txs.some(
                  (tx) => tx.transactionType === "Disposed"
                );

                // Check if a "Clear for Disposal" transaction exists
                const clearForDisposalTxExists = txs.some(
                  (tx) => tx.transactionType === "Clear for Disposal"
                );

                // If "Clear for Disposal" is missing and plannedDisposalDate is available, add it
                if (
                  !clearForDisposalTxExists &&
                  vals.inventoryItems[0]?.plannedDisposalDate
                ) {
                  const plannedDate =
                    vals.inventoryItems[0].plannedDisposalDate;
                  const authBy =
                    vals.inventoryItems[0].disposalAuthorizedBy || "N/A";
                  const disposalType =
                    vals.inventoryItems[0].plannedDisposalType;
                  const commentClear = `SCHEDULED FOR DISPOSAL (${disposalType}) ON ${plannedDate}, AUTHORIZED BY ${authBy}`;
                  const newClearTx = {
                    inventoryItemTransactionId: null,
                    dateAdded: !fullSearch ? dayjs().format("MM/DD/YYYY") : null,
                    timeAdded: !fullSearch ? dayjs().format("HH:mm") : null,
                    user: "System",
                    transactionType: "Clear for Disposal",
                    comments: commentClear,
                    inventoryItemTransactionsExtras: [],
                  };
                  txs = [...txs, newClearTx];
                }

                // Then add the "Disposed" transaction if it doesn't exist
                if (!disposalTxExists) {
                  const plannedDate = vals.inventoryItems[0].disposalDate;
                  const transferredTo =
                    vals.inventoryItems[0].transferredTo || "N/A";
                  const disposalType = vals.inventoryItems[0].disposalType;
                  const comment = `DISPOSED OF (${disposalType}) ON ${plannedDate}, TRANSFERRED TO ${transferredTo}`;
                  const newTx = {
                    inventoryItemTransactionId: null,
                    dateAdded: !fullSearch ? dayjs().format("MM/DD/YYYY") : null,
                    timeAdded: !fullSearch ? dayjs().format("HH:mm") : null,
                    user: "System",
                    transactionType: "Disposed",
                    comments: comment,
                    inventoryItemTransactionsExtras: [],
                  };
                  txs = [...txs, newTx];
                }

                // Clear storage locations and set the item status
                vals.inventoryItems[0].storageLocation1Id = "";
                vals.inventoryItems[0].storageLocation2Id = "";
                vals.inventoryItems[0].storageLocation3Id = "";
                vals.inventoryItems[0].itemStatus = "Disposed";
              }
            }

            case "Revoke Clearance": {
            }
            default: {
              // Only add a new Checked In if no unpaired one exists
              let unpaired = false;
              txs.forEach((tx) => {
                if (tx.transactionType === "Initial Entry") {
                  unpaired = true;
                }
              });
              if (!unpaired && !fullSearch) {
                const loc1 =
                  form.getFieldValue([
                    "inventoryItems",
                    0,
                    "storageLocation1Id",
                  ]) || "";
                const loc2 =
                  form.getFieldValue([
                    "inventoryItems",
                    0,
                    "storageLocation2Id",
                  ]) || "";
                const loc3 =
                  form.getFieldValue([
                    "inventoryItems",
                    0,
                    "storageLocation3Id",
                  ]) || "";
                // Retrieve the location options from the reference list.
                const storageLocation1Options = getOptionsFromRefList(
                  "Storage_Location_1",
                  false,
                  false,
                  true
                );
                const storageLocation2Options = getOptionsFromRefList(
                  "Inmate_Property_Storage_Location_1",
                  false,
                  false,
                  true
                );
                const storageLocation3Options = getOptionsFromRefList(
                  "Inmate_Property_Storage_Location_2",
                  false,
                  false,
                  true
                );

                // Lookup the label for each location value.
                const loc1Name =
                  storageLocation1Options.find((opt) => opt.value === loc1)
                    ?.label || loc1;
                const loc2Name =
                  storageLocation2Options.find((opt) => opt.value === loc2)
                    ?.label || loc2;
                const loc3Name =
                  storageLocation3Options.find((opt) => opt.value === loc3)
                    ?.label || loc3;

                const locationComment = `ORIGINAL STORAGE: ${loc1Name}:${loc2Name}:${loc3Name}`;
                const newTx = {
                  inventoryItemTransactionId: null,
                  dateAdded: !fullSearch ? dayjs().format("MM/DD/YYYY") : null,
                  timeAdded: !fullSearch ? dayjs().format("HH:mm") : null,
                  user: "System",
                  transactionType: "Initial Entry",
                  comments: !fullSearch ? locationComment : null,
                  inventoryItemTransactionsExtras: [],
                };
                txs = [...txs, newTx];
              }
              break;
            }
          }
          vals.inventoryItemTransactions = txs;
          return vals;
        };
        values.inventoryItems[0].itemStatus = itemStatus;
        // Update custody transactions based on current itemStatus
        const updatedValues = updateTransactionsForStatus(values);

        return updatedValues;
      },

      resetForm: () => {
        form.resetFields();
        imageForm.resetFields();
        setPhotoList([]);
      },
      validateFields: () =>
        Promise.all([form.validateFields(), imageForm.validateFields()]),
    }));

    const specialHandling = Form.useWatch(
      ["inventoryItems", 0, "specialHandling"],
      form
    );

    const showCheckOutItemConfirm = () => {
      setCheckOutItemConfirm(true);
    };

    const hideCheckOutItemConfirm = () => {
      setCheckOutItemConfirm(false);
    };

    const getFinalPath = (path) => {
      if (path?.includes("\\")) {
        const splitPath = path.split("/");
        if (splitPath.length === 4) {
          splitPath.shift();
          splitPath.shift();
        }
        return splitPath.join("\\");
      }
      return path;
    };

    // When custody transactions update in the custody details component, store them locally.
    // The PropertyChainCustodyDetails component calls this callback.
    const handleTransactionsUpdate = (transactions) => {
      setCustodyTransactions(transactions);
    };

    const handleRevokeDisposalClearance = () => {
      form.setFieldValue(["inventoryItems", 0, "disposalType"], undefined);
      form.setFieldValue(["inventoryItems", 0, "disposalDate"], undefined);
      form.setFieldValue(["inventoryItems", 0, "final_Description"], undefined);
      form.setFieldValue(["inventoryItems", 0, "transferredTo"], undefined);
      form.setFieldValue(["inventoryItems", 0, "returnedTo"], undefined);
      form.setFieldValue(
        ["inventoryItems", 0, "plannedDisposalType"],
        undefined
      );
      form.setFieldValue(
        ["inventoryItems", 0, "plannedDisposalDate"],
        undefined
      );
      form.setFieldValue(
        ["inventoryItems", 0, "disposalAuthorizedBy"],
        undefined
      );
      form.setFieldValue(
        ["inventoryItems", 0, "disposalInstructions"],
        undefined
      );

      // Create a new revoke transaction
      const newRevokeTx = {
        inventoryItemTransactionId: null,
        dateAdded: !fullSearch ? dayjs().format("MM/DD/YYYY") : null,
        timeAdded: !fullSearch ? dayjs().format("HH:mm") : null,
        user: "System",
        transactionType: "Revoke Clearance",
        comments: "DISPOSAL CLEARANCE REVOKED",
        inventoryItemTransactionsExtras: [],
      };

      let unpaired = false;
      custodyTransactions.forEach((tx) => {
        if (tx.transactionType === "Revoke Clearance") {
          unpaired = true;
        } else if (tx.transactionType === "Clear for Disposal" && unpaired) {
          unpaired = false;
        }
      });
      if (!unpaired) {
        // Update the custodyTransactions state immediately
        const updatedTransactions = [...custodyTransactions, newRevokeTx];
        setCustodyTransactions(updatedTransactions);

        // Also update the propertyItem's inventoryItemTransactions so that the custody details component refreshes
        setPropertyItem((prev) => ({
          ...prev,
          inventoryItemTransactions: updatedTransactions,
        }));
        setItemStatus("Revoke Clearance");
      }

      // Reset disposal flags and clear disposal-related fields so that no further disposal actions occur.
      setIsClearForDisposal(false);
      setIsDisposalCleared(false);
    };

    // -------------------------------
    // File selection does not immediately trigger the upload.
    // Instead, store the file in pendingFile.
    // -------------------------------
    const handleFileUpload = (file) => {
      setPendingFile(file);
    };

    // -------------------------------
    // When Save is clicked in the Photo Information modal, perform the upload if a file was selected,
    // or update details if editing without a new file.
    // -------------------------------
    const onSaveClick = () => {
      if (pendingFile) {
        const formDataObj = new FormData();
        formDataObj.append("file", pendingFile);
        formDataObj.append("imageType", imageForm.getFieldValue("imgType"));

        const config = {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        };

        api
          .post(API_ENDPOINTS.imageUpload, formDataObj, config)
          .then((response) => {
            const body = response?.data?.body;
            const finalPath =
              PHOTOS_BASE_URL + getFinalPath(body?.fullSizePath);

            const newPhoto = {
              propertyPhotoId: editingPhoto
                ? editingPhoto.propertyPhotoId
                : null,
              photoId: editingPhoto ? editingPhoto.photoId : uuidV4(),
              propertyId: editingPhoto ? editingPhoto.propertyId : null,
              fullSizePath: body?.fullSizePath,
              thumbnailPath: body?.fullSizePath,
              imageType: imageForm.getFieldValue("imgType"),
              description: imageForm.getFieldValue("description"),
              dateAdded: !fullSearch ? dayjs().format("MM/DD/YYYY") : null,
              timeAdded: !fullSearch ? dayjs().format("HH:mm") : null,
              user: "System",
              creatorStaffId: 17647,
            };

            if (editingPhoto) {
              setPhotoList((prev) =>
                prev.map((p) =>
                  p.photoId === editingPhoto.photoId ? newPhoto : p
                )
              );
              setEditingPhoto(null);
            } else {
              setPhotoList((prev) => [...prev, newPhoto]);
            }
            setImgData(newPhoto.fullSizePath);
            setPendingFile(null);
            imageForm.resetFields();
            setShowPhotoInformation(false);
          })
          .catch((error) => {
            console.error("Error uploading image:", error);
          });
      } else if (editingPhoto) {
        // If editing and no new file was selected, update the details.
        const updatedPhoto = {
          ...editingPhoto,
          imageType: imageForm.getFieldValue("imgType"),
          description: imageForm.getFieldValue("description"),
          // Do not update fullSizePath if no new file was uploaded.
        };
        setPhotoList((prev) =>
          prev.map((p) =>
            p.photoId === editingPhoto.photoId ? updatedPhoto : p
          )
        );
        setEditingPhoto(null);
        setShowPhotoInformation(false);
      } else {
        // If no file selected and not editing, just close the modal.
        setShowPhotoInformation(false);
      }
    };

    // -------------------------------
    // Details and DELETE functionality for photos.
    // -------------------------------
    const handleViewEditPhoto = (record) => {
      const currentPhoto = record?.photoId ? record : selectedPhoto;

      if (!currentPhoto) {
        alert("Please select a photo to details.");
        return;
      }

      setSelectedPhoto(currentPhoto);
      setItemStatus(currentPhoto.itemStatus);
      setImgData(currentPhoto.fullSizePath);
      setEditingPhoto(currentPhoto);

      imageForm.setFieldsValue({
        imgType: currentPhoto.imageType,
        description: currentPhoto.description,
        fullSizePath: currentPhoto.fullSizePath,
      });

      setShowPhotoInformation(true);
    };

    const handleDeletePhoto = () => {
      if (selectedPhoto) {
        setPhotoList((prev) =>
          prev.filter((p) => p.photoId !== selectedPhoto.photoId)
        );
        setSelectedPhoto(null);
      } else {
        alert("Please select a photo to delete.");
      }
    };
    useEffect(() => {
      if (isEdit) {
        let isShow = hasCheckSecurity(
          Security_Types.functionality,
          Entity_types.subModule,
          LABELS_CAPITAL.MODIFY,
          MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
          SUB_MODULES_LIST_WITH_ID.Inmate_Property
        );
        if (isShow) {
          setIsDisabled(false);
        } else {
          setIsDisabled(true);
        }
      } else {
        setIsDisabled(false);
      }
    }, [isEdit]);
    useEffect(() => {
      console.log({ isDisabled, isEdit });
    }, [isDisabled]);
    return (
      <>
        <Modal
          show={show}
          header={propertyItem != null ? "Modify Item" : "Add Item"}
          handleCancel={handleCancel}
          handleSubmit={handleSubmit}
          onHide={handleCancel}
          designPattern="ant"
          width="70%"
          className="unstyle-padding"
          hideSubmitButton={isDisabled}
        >
          <StyledModalContent>
            <StyledGridRow className="styled-modal-header">
              <StyledGridCol>
                {!isDisposalCleared && (
                  <>
                    {itemStatus === "Checked Out" ? (
                      <Popconfirm
                        className="bordered"
                        open={checkInItemConfirm}
                        title="Who is returning the item?"
                        okText="OK"
                        cancelText="Cancel"
                        onConfirm={() => {
                          if (!checkInText.trim()) {
                            alert("Please enter a name.");
                            return;
                          }
                          if (
                            custodyDetailsRef.current &&
                            custodyDetailsRef.current.openModalWithComment
                          ) {
                            custodyDetailsRef.current.openModalWithComment({
                              comments: `RECEIVED FROM: ${checkInText}`,
                              transactionType: "Checked In",
                            });
                          }
                          setItemStatus("Checked In");
                          setCheckedOutBy("");
                          form.setFieldValue(
                            ["inventoryItems", 0, "itemStatus"],
                            "Checked In"
                          );
                          setCheckInText("");
                          setCheckInItemConfirm(false);
                        }}
                        onCancel={() => {
                          setCheckInItemConfirm(false);
                          setItemStatus("Checked Out");
                        }}
                        cancelMessage="Cancelled by user."
                        content={
                          <TextField
                            placeholder="Enter Name"
                            value={checkInText}
                            onChange={(e) => setCheckInText(e.target.value)}
                          />
                        }
                      >
                        <Button
                          type="default"
                          color="default"
                          onClick={() => setCheckInItemConfirm(true)}
                          disabled={!bookingsFieldsEnabled}
                        >
                          Check Item Back In
                        </Button>
                      </Popconfirm>
                    ) : (
                      <Popconfirm
                        className="bordered"
                        open={checkOutItemConfirm}
                        title="To whom is the item being checked out?"
                        okText="OK"
                        cancelText="Cancel"
                        onConfirm={() => {
                          if (!checkoutText.trim()) {
                            alert("Please enter a name.");
                            return;
                          }
                          if (
                            custodyDetailsRef.current &&
                            custodyDetailsRef.current.openModalWithComment
                          ) {
                            custodyDetailsRef.current.openModalWithComment({
                              comments: `RECEIVED BY: ${checkoutText}`,
                              transactionType: "Checked Out",
                            });
                          }
                          setItemStatus("Checked Out");
                          setCheckedOutBy(checkoutText);
                          form.setFieldValue(
                            ["inventoryItems", 0, "itemStatus"],
                            "Checked Out"
                          );
                          setCheckoutText("");
                          setCheckOutItemConfirm(false);
                        }}
                        onCancel={() => {
                          hideCheckOutItemConfirm();
                          setItemStatus("Checked In");
                        }}
                        cancelMessage="Cancelled by user."
                        content={
                          <TextField
                            placeholder="Enter Name"
                            value={checkoutText}
                            onChange={(e) => setCheckoutText(e.target.value)}
                          />
                        }
                      >
                        <Button
                          type="default"
                          color="default"
                          onClick={showCheckOutItemConfirm}
                          disabled={!bookingsFieldsEnabled}
                        >
                          Check Out Item
                        </Button>
                      </Popconfirm>
                    )}

                    {!isClearForDisposal && !isDisposalCleared && (
                      <Button
                        type="default"
                        color="default"
                        disabled={!bookingsFieldsEnabled}
                        onClick={() => {
                          form.setFieldValue(
                            ["inventoryItems", 0, "plannedDisposalType"],
                            null
                          );
                          form.setFieldValue(
                            ["inventoryItems", 0, "plannedDisposalDate"],
                            null
                          );
                          form.setFieldValue(
                            ["inventoryItems", 0, "disposalAuthorizedBy"],
                            undefined
                          );
                          form.setFieldValue(
                            ["inventoryItems", 0, "disposalInstructions"],
                            undefined
                          );
                          setIsClearForDisposal(true);
                          setItemStatus("Clear for Disposal");
                          // Set the hidden field value to true so that it is sent along with the form data.
                          form.setFieldValue(
                            ["inventoryItems", 0, "clearedForDisposal"],
                            true
                          );
                        }}
                      >
                        Clear for Disposal
                      </Button>
                    )}
                  </>
                )}
                {isClearForDisposal && !isDisposalCleared && (
                  <>
                    <Button
                      type="default"
                      color="default"
                      onClick={() => {
                        setIsDisposalCleared(true);
                        setItemStatus("Disposed");
                      }}
                      disabled={!bookingsFieldsEnabled}
                    >
                      Dispose
                    </Button>
                    {!isDisposalCleared && (
                      <Button
                        type="default"
                        color="default"
                        onClick={handleRevokeDisposalClearance}
                        disabled={!bookingsFieldsEnabled}
                      >
                        Revoke Disposal Clearance
                      </Button>
                    )}
                  </>
                )}

                <Button
                  type="default"
                  color="default"
                  onClick={() => setIsChainCustodyReport(true)}
                  disabled={custodyTransactions.length === 0 || !bookingsFieldsEnabled}
                >
                  Chain of Custody
                </Button>
              </StyledGridCol>
            </StyledGridRow>
            <FormContainer className="styled-modal-content">
              <Form
                form={form}
                initialValues={propertyItem}
                onFinish={handleSubmit}
              >
                <Fragment>
                  <Divider
                    orientation="left"
                    style={{ borderColor: "#00000080" }}
                  >
                    Item Information
                  </Divider>
                  <StyledGridRow gutter={[16]}>
                    <StyledGridCol span={6}>
                      <FormItem
                        name="inmatePropertyType"
                        label={labels.propType}
                        rules={ !fullSearch ? [
                          {
                            required: true,
                            message: `${labels.propType} is required`,
                          },
                        ] : []}
                      >
                        <Select
                          placeholder={"Prop Type"}
                          showSearch={true}
                          options={getOptionsFromRefList("PropertyType")}
                          getPopupContainer={(trigger) => trigger.parentNode}
                          disabled={!bookingsFieldsEnabled}
                        />
                      </FormItem>
                    </StyledGridCol>
                  </StyledGridRow>
                </Fragment>

                <Fragment>
                  <Divider
                    orientation="left"
                    style={{ borderColor: "#00000080" }}
                  >
                    Inventory Details
                  </Divider>
                  <StyledGridRow gutter={[16]}>
                    <StyledGridCol lg={16}>
                      <StyledGridRow gutter={[16]}>
                        <StyledGridCol xs={6}>
                          <FormItem
                            name={["inventoryItems", 0, "storageLocation1Id"]}
                            label={labels.context}
                            rules={ !fullSearch ? [
                              ({ getFieldValue }) => ({
                                validator(_, value) {
                                  const status = getFieldValue([
                                    "inventoryItems",
                                    0,
                                    "itemStatus",
                                  ]);
                                  if (status === "Disposed" || value) {
                                    return Promise.resolve();
                                  }
                                  return Promise.reject(
                                    `${labels.context} is required`
                                  );
                                },
                              }),
                            ] : []}
                          >
                            <Select
                              placeholder={labels.context}
                              showSearch={true}
                              options={getOptionsFromRefList(
                                "Storage_Location_1",
                                false,
                                false,
                                true
                              )}
                              disabled={true}
                              getPopupContainer={(trigger) =>
                                trigger.parentNode
                              }
                            />
                          </FormItem>
                        </StyledGridCol>
                        <StyledGridCol xs={6}>
                          <FormItem
                            name={["inventoryItems", 0, "storageLocation2Id"]}
                            label={labels.location1}
                            rules={!fullSearch ? [
                              ({ getFieldValue }) => ({
                                validator(_, value) {
                                  const status = getFieldValue([
                                    "inventoryItems",
                                    0,
                                    "itemStatus",
                                  ]);
                                  if (status === "Disposed" || value) {
                                    return Promise.resolve();
                                  }
                                  return Promise.reject(
                                    `${labels.location1} is required`
                                  );
                                },
                              }),
                            ] : []}
                          >
                            <Select
                              placeholder={labels.location1}
                              showSearch={true}
                              options={getOptionsFromRefList(
                                "Inmate_Property_Storage_Location_1",
                                false,
                                false,
                                true
                              )}
                              getPopupContainer={(trigger) =>
                                trigger.parentNode
                              }
                              disabled={!bookingsFieldsEnabled}
                            />
                          </FormItem>
                        </StyledGridCol>
                        <StyledGridCol xs={6}>
                          <FormItem
                            name={["inventoryItems", 0, "storageLocation3Id"]}
                            label={labels.location2}
                            rules={!fullSearch ? [
                              ({ getFieldValue }) => ({
                                validator(_, value) {
                                  const status = getFieldValue([
                                    "inventoryItems",
                                    0,
                                    "itemStatus",
                                  ]);
                                  if (status === "Disposed" || value) {
                                    return Promise.resolve();
                                  }
                                  return Promise.reject(
                                    `${labels.location2} is required`
                                  );
                                },
                              }),
                            ] : []}
                          >
                            <Select
                              placeholder={labels.location2}
                              showSearch={true}
                              options={getOptionsFromRefList(
                                "Inmate_Property_Storage_Location_2",
                                false,
                                false,
                                true
                              )}
                              getPopupContainer={(trigger) =>
                                trigger.parentNode
                              }
                              disabled={!bookingsFieldsEnabled}
                            />
                          </FormItem>
                        </StyledGridCol>
                        <StyledGridCol xs={6}>
                          <FormItem
                            name={["inventoryItems", 0, "barCodeNumber"]}
                            label={labels.barCodeNumber}
                          >
                            <TextField disabled />
                          </FormItem>
                        </StyledGridCol>
                        <StyledGridCol xs={8}>
                          <FormItem
                            name={["inventoryItems", 0, "storageInstructions"]}
                            label="Storage Instructions"
                          >
                            <Select
                              placeholder={"Storage Instructions"}
                              showSearch={true}
                              options={getOptionsFromRefList(
                                "Storage_Instructions"
                              )}
                              getPopupContainer={(trigger) =>
                                trigger.parentNode
                              }
                              disabled={!bookingsFieldsEnabled}
                            />
                          </FormItem>
                        </StyledGridCol>
                        <StyledGridCol xs={8}>
                          <FormItem
                            name={["inventoryItems", 0, "specialHandling"]}
                            label="Special Handling"
                          >
                            <Select
                              placeholder="Special Handling"
                              showSearch={true}
                              options={getOptionsFromRefList(
                                "Special_Handling"
                              )}
                              getPopupContainer={(trigger) =>
                                trigger.parentNode
                              }
                              disabled={!bookingsFieldsEnabled}
                            />
                          </FormItem>
                        </StyledGridCol>
                        {isNonEmptyVariable(specialHandling) &&
                          specialHandling !== "None" && (
                            <>
                              {specialHandling === "Biohazardous" ? (
                                <StyledGridCol xs={8}>
                                  <FormItem
                                    name={[
                                      "inventoryItems",
                                      0,
                                      "biohazardousType",
                                    ]}
                                    label="Biohazardous Type"
                                  >
                                    <Select
                                      placeholder="Biohazardous Type"
                                      showSearch={true}
                                      options={getOptionsFromRefList(
                                        "Biohazardous_Type"
                                      )}
                                      getPopupContainer={(trigger) =>
                                        trigger.parentNode
                                      }
                                      disabled={!bookingsFieldsEnabled}
                                    />
                                  </FormItem>
                                </StyledGridCol>
                              ) : (
                                <StyledGridCol xs={8}>
                                  <FormItem
                                    name={[
                                      "inventoryItems",
                                      0,
                                      "hazardousType",
                                    ]}
                                    label="Hazardous Type"
                                  >
                                    <Select
                                      placeholder="Hazardous Type"
                                      showSearch={true}
                                      options={getOptionsFromRefList(
                                        "Hazardous_Type"
                                      )}
                                      getPopupContainer={(trigger) =>
                                        trigger.parentNode
                                      }
                                      disabled={!bookingsFieldsEnabled}
                                    />
                                  </FormItem>
                                </StyledGridCol>
                              )}
                            </>
                          )}
                      </StyledGridRow>
                    </StyledGridCol>
                    <StyledGridCol lg={8}>
                      <StyledGridRow gutter={[16]}>
                        <StyledGridCol xs={20}>
                          {!isClearForDisposal && !isDisposalCleared && (
                            <FormItem
                              name={["inventoryItems", 0, "itemStatus"]}
                              label=""
                              style={{ paddingLeft: "15px" }}
                            >
                              {itemStatus === "Checked Out" ? (
                                <Alert
                                  type="warning"
                                  message={
                                    <h5
                                      style={{
                                        textAlign: "center",
                                        margin: "0px",
                                      }}
                                    >
                                      Checked Out by: {checkedOutBy}
                                    </h5>
                                  }
                                  show={true}
                                  closable={false}
                                />
                              ) : (
                                <Alert
                                  type="success"
                                  message={
                                    <h5
                                      style={{
                                        textAlign: "center",
                                        margin: "0px",
                                      }}
                                    >
                                      Checked In
                                    </h5>
                                  }
                                  show={true}
                                  closable={false}
                                />
                              )}
                            </FormItem>
                          )}

                          {isClearForDisposal && (
                            <FormItem label="" style={{ paddingLeft: "15px" }}>
                              <Alert
                                type="success"
                                message={
                                  <h5
                                    style={{
                                      textAlign: "center",
                                      margin: "0px",
                                    }}
                                  >
                                    Cleared for Disposal
                                  </h5>
                                }
                                show={true}
                                closable={false}
                              />
                            </FormItem>
                          )}
                          {isDisposalCleared && (
                            <FormItem label="" style={{ paddingLeft: "15px" }}>
                              <Alert
                                type="error"
                                message={
                                  <h5
                                    style={{
                                      textAlign: "center",
                                      margin: "0px",
                                    }}
                                  >
                                    Disposed
                                  </h5>
                                }
                                show={true}
                                closable={false}
                              />
                            </FormItem>
                          )}
                        </StyledGridCol>
                      </StyledGridRow>
                    </StyledGridCol>
                    <StyledGridCol span={24}>
                      <FormItem
                        name={["inventoryItems", 0, "comments"]}
                        label={labels.comments}
                      >
                        <TextField
                          inputType="textarea"
                          name="comments"
                          placeholder="Comments"
                          required
                          disabled={!bookingsFieldsEnabled}
                        />
                      </FormItem>
                    </StyledGridCol>
                  </StyledGridRow>
                </Fragment>

                {isClearForDisposal && (
                  <Fragment>
                    <Divider
                      orientation="left"
                      style={{ borderColor: "#00000080", marginBottom: "4px" }}
                    >
                      Details About Item Disposal{" "}
                      <small style={{ fontWeight: "400" }}>
                        (Items that will no longer be maintained in inventory)
                      </small>
                    </Divider>
                    <h6 style={{ marginTop: "10px" }}>
                      Planned Disposal Information
                    </h6>
                    <StyledGridRow gutter={16}>
                      <StyledGridCol xs={7}>
                        <FormItem
                          label="Planned Disposal Method"
                          name={["inventoryItems", 0, "plannedDisposalType"]}
                          rules={!fullSearch ? [
                            {
                              required: true,
                              message: "Planned Disposal Method is required",
                            },
                          ] : []}
                        >
                          <Select
                            placeholder="Select Disposal Type"
                            showSearch={true}
                            options={getOptionsFromRefList("Disposal_Type")}
                            getPopupContainer={(trigger) => trigger.parentNode}
                            disabled={!bookingsFieldsEnabled}
                          />
                        </FormItem>
                        <FormItem
                          name={["inventoryItems", 0, "clearedForDisposal"]}
                          hidden
                        >
                          <TextField disabled={!bookingsFieldsEnabled} />
                        </FormItem>
                      </StyledGridCol>
                      <StyledGridCol xs={5}>
                        <FormItem
                          label="Date"
                          name={["inventoryItems", 0, "plannedDisposalDate"]}
                          rules={!fullSearch ? [
                            {
                              required: true,
                              message: "Disposal Date is required",
                            },
                          ] : []}
                        >
                          <CommonDatePicker
                            showTime={false}
                            format={"MM/DD/YYYY"}
                            placeholder={"MM/DD/YYYY"}
                            disabled={!bookingsFieldsEnabled}
                          />
                        </FormItem>
                      </StyledGridCol>
                      <StyledGridCol xs={6}>
                        <FormItem
                          label="Authorized By"
                          name={["inventoryItems", 0, "disposalAuthorizedBy"]}
                          rules={!fullSearch ? [
                            {
                              required: true,
                              message: "Authorized By is required",
                            },
                          ] : []}
                        >
                          <TextField placeholder="Enter name" disabled={!bookingsFieldsEnabled}/>
                        </FormItem>
                      </StyledGridCol>
                      <StyledGridCol xs={6}>
                        <FormItem
                          label="Disposal Instructions"
                          name={["inventoryItems", 0, "disposalInstructions"]}
                          rules={!fullSearch ? [
                            {
                              required: true,
                              message: "Disposal Instructions are required",
                            },
                          ] : []}
                        >
                          <TextField placeholder="Instructions" disabled={!bookingsFieldsEnabled}/>
                        </FormItem>
                      </StyledGridCol>
                    </StyledGridRow>
                  </Fragment>
                )}
                {isDisposalCleared && (
                  <Fragment>
                    <h6>Actual Disposal Information</h6>
                    <StyledGridRow gutter={16}>
                      <StyledGridCol xs={7}>
                        <FormItem
                          label="Actual Disposal Method"
                          name={["inventoryItems", 0, "disposalType"]}
                          rules={ !fullSearch ? [
                            {
                              required: true,
                              message: "Actual Disposal Method is required",
                            },
                          ] : []}
                        >
                          <Select
                            placeholder="Select Disposal Method"
                            showSearch={true}
                            options={getOptionsFromRefList("Disposal_Type")}
                            getPopupContainer={(trigger) => trigger.parentNode}
                            disabled={!bookingsFieldsEnabled}
                          />
                        </FormItem>
                      </StyledGridCol>
                      <StyledGridCol xs={5}>
                        <FormItem
                          label="Date"
                          name={["inventoryItems", 0, "disposalDate"]}
                          rules={!fullSearch ? [
                            {
                              required: true,
                              message: "Disposal Date is required",
                            },
                          ] : []}
                        >
                          <CommonDatePicker
                            showTime={false}
                            format={"MM/DD/YYYY"}
                            placeholder={"MM/DD/YYYY"}
                            disabled={!bookingsFieldsEnabled}
                          />
                        </FormItem>
                      </StyledGridCol>
                      <StyledGridCol xs={12}>
                        <FormItem
                          label="Final Description"
                          name={["inventoryItems", 0, "final_Description"]}
                          rules={!fullSearch ? [
                            {
                              required: true,
                              message: "Final Description is required",
                            },
                          ] : []}
                        >
                          <TextField placeholder="Enter final description" disabled={!bookingsFieldsEnabled}/>
                        </FormItem>
                      </StyledGridCol>
                      {disposalType !== "Return to Owner" && (
                        <StyledGridCol xs={8}>
                          <FormItem
                            label="Transferred To"
                            name={["inventoryItems", 0, "transferredTo"]}
                            rules={!fullSearch ? [
                              {
                                required: true,
                                message: "Transferred To is required",
                              },
                            ] : []}
                          >
                            <TextField placeholder="Enter name" disabled={!bookingsFieldsEnabled}/>
                          </FormItem>
                        </StyledGridCol>
                      )}
                      <StyledGridCol xs={8}>
                        <FormItem
                          label="Returned To"
                          name={["inventoryItems", 0, "returnedTo"]}
                          rules={!fullSearch ? [
                            {
                              required: true,
                              message: "Returned To is required",
                            },
                          ] : []}
                        >
                          <TextField placeholder="Enter name" disabled={!bookingsFieldsEnabled}/>
                        </FormItem>
                      </StyledGridCol>
                    </StyledGridRow>
                  </Fragment>
                )}

                <Fragment>
                  <Divider
                    orientation="left"
                    style={{ borderColor: "#00000080" }}
                  >
                    Property Information
                  </Divider>
                  <StyledGridRow gutter={[16]}>
                    <StyledGridCol span={5}>
                      <FormItem
                        name={[
                          "inventoryItems",
                          0,
                          "propertyCommon",
                          0,
                          "propertyType",
                        ]}
                        label="Property Type"
                      >
                        <Select
                          placeholder="Property Type"
                          showSearch={true}
                          options={getOptionsFromRefList("Property_Type")}
                          getPopupContainer={(trigger) => trigger.parentNode}
                          disabled={!bookingsFieldsEnabled}
                        />
                      </FormItem>
                    </StyledGridCol>
                    <StyledGridCol
                      span={4}
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <FormItem
                        name={[
                          "inventoryItems",
                          0,
                          "propertyCommon",
                          0,
                          "weapon",
                        ]}
                        valuePropName="checked"
                        label={labels.weapon}
                      >
                        <Checkbox style={{ flex: "1" }} disabled={!bookingsFieldsEnabled} />
                      </FormItem>
                    </StyledGridCol>
                    <StyledGridCol span={3}>
                      <FormItem
                        name={[
                          "inventoryItems",
                          0,
                          "propertyCommon",
                          0,
                          "value",
                        ]}
                        label={labels.itemValue}
                      >
                        <TextField placeholder="Item value" disabled={!bookingsFieldsEnabled} />
                      </FormItem>
                    </StyledGridCol>
                    <StyledGridCol span={3}>
                      <FormItem
                        name={[
                          "inventoryItems",
                          0,
                          "propertyCommon",
                          0,
                          "quality",
                        ]}
                        label="Quality"
                      >
                        <Select
                          placeholder="Quality"
                          showSearch={true}
                          options={getOptionsFromRefList("Quality")}
                          getPopupContainer={(trigger) => trigger.parentNode}
                          disabled={!bookingsFieldsEnabled}
                        />
                      </FormItem>
                    </StyledGridCol>
                    <StyledGridCol span={3}>
                      <FormItem
                        name={[
                          "inventoryItems",
                          0,
                          "propertyCommon",
                          0,
                          "quantity",
                        ]}
                        label={labels.qunatity}
                        rules={!fullSearch ? [
                          {
                            required: true,
                            message: `${labels.qunatity} is required`,
                          },
                        ] : []}
                      >
                        <TextField
                          placeholder="Quantity"
                          onKeyDown={(e) => {
                            if (
                              e.key.match(/[^0-9]/) &&
                              e.key !== "Backspace" &&
                              e.key !== "Tab" &&
                              e.key !== "ArrowLeft" &&
                              e.key !== "ArrowRight"
                            ) {
                              e.preventDefault();
                            }
                          }}
                          name="quantity"
                          required
                          disabled={!bookingsFieldsEnabled}
                        />
                      </FormItem>
                    </StyledGridCol>
                    <StyledGridCol span={5}>
                      <FormItem
                        name={[
                          "inventoryItems",
                          0,
                          "propertyCommon",
                          0,
                          "color",
                        ]}
                        label={labels.itemColor}
                        rules={!fullSearch ? [
                          {
                            required: true,
                            message: `${labels.itemColor} is required`,
                          },
                        ] : []}
                      >
                        <Select
                          placeholder={"color"}
                          showSearch={true}
                          options={getOptionsFromRefList("PropertyColor")}
                          getPopupContainer={(trigger) => trigger.parentNode}
                          disabled={!bookingsFieldsEnabled}
                        />
                      </FormItem>
                    </StyledGridCol>
                    <StyledGridCol span={24}>
                      <FormItem
                        name={[
                          "inventoryItems",
                          0,
                          "propertyCommon",
                          0,
                          "description",
                        ]}
                        label={labels.description}
                      >
                        <TextField
                          inputType="textarea"
                          rows={5}
                          name="description"
                          placeholder="Description"
                          disabled={!bookingsFieldsEnabled}
                        />
                      </FormItem>
                    </StyledGridCol>
                  </StyledGridRow>
                </Fragment>

                <Fragment>
                  <Divider
                    orientation="left"
                    style={{ borderColor: "#00000080" }}
                  >
                    Agency-Specific Information for Property (Common)
                  </Divider>
                  <StyledGridRow gutter={16}>
                    <StyledGridCol xs={8}>
                      <FormItem
                        label="Owner Applied Number"
                        name="ownerAppliedNumber"
                      >
                        <TextField disabled={!bookingsFieldsEnabled} />
                      </FormItem>
                      <FormItem name="propertyExtraId" hidden>
                        <input type="hidden" />
                      </FormItem>
                    </StyledGridCol>
                  </StyledGridRow>
                </Fragment>

                <Fragment>
                  <Divider
                    orientation="left"
                    style={{ borderColor: "#00000080" }}
                  >
                    Property Photos
                  </Divider>
                </Fragment>

                <StyledGridRow gutter={16}>
                  <StyledGridCol lg={16}>
                    <InmateDetailsTableContainer>
                      <TableHeader>
                        <h6>List of Photos</h6>
                        <div className="right">
                          <Button
                            onClick={clickPhotoInformation}
                            disabled={!bookingsFieldsEnabled}
                          >
                            Add
                          </Button>
                          <Button
                            onClick={handleViewEditPhoto}
                            style={{ marginLeft: "10px" }}
                            disabled={!selectedPhoto}
                          >
                            Details
                          </Button>
                          <Popconfirm
                            title="Delete the Alias"
                            description="Are you sure to delete this Alias?"
                            onConfirm={handleDeletePhoto}
                            onCancel={() => {}}
                            okText="Yes"
                            cancelText="No"
                          >
                            <Button
                              style={{ marginLeft: "10px" }}
                              disabled={!bookingsFieldsEnabled || !selectedPhoto}
                            >
                              Delete
                            </Button>
                          </Popconfirm>
                        </div>
                      </TableHeader>
                      <Table
                        style={{ padding: "unset" }}
                        headers={[{ key: "description", text: "Description" }]}
                        data={photoList}
                        onRowClick={(record) => {
                          setSelectedPhoto(record);
                          setItemStatus(record.itemStatus);
                          setImgData(record.fullSizePath);
                        }}
                        onRowDoubleClick={(record) => {
                          handleViewEditPhoto(record);
                        }}
                      />
                    </InmateDetailsTableContainer>
                  </StyledGridCol>
                  <StyledGridCol lg={8}>
                    <FormItem>
                      <img
                        src={
                          imgData
                            ? PHOTOS_BASE_URL + getFinalPath(imgData)
                            : emptyImage
                        }
                        width="100%"
                        style={{ border: "1px solid rgba(0,0,0,0.1)" }}
                        alt="Property"
                      />
                    </FormItem>
                  </StyledGridCol>
                </StyledGridRow>

                <Fragment>
                  <Divider
                    orientation="left"
                    style={{ borderColor: "#00000080" }}
                  >
                    Chain of custody
                  </Divider>
                  <PropertyChainCustodyDetails
                    formData={propertyItem}
                    onTransactionsUpdate={handleTransactionsUpdate}
                    ref={custodyDetailsRef}
                  />
                </Fragment>
              </Form>
            </FormContainer>
          </StyledModalContent>
        </Modal>

        <Modal
          header={"Photo Information"}
          show={showPhotoInformation}
          size="md"
          onHide={() => setShowPhotoInformation(false)}
          footerActions={[{ key: "save", text: "Save", onClick: onSaveClick, disabled: !bookingsFieldsEnabled }]}
          footerCloseAction
          footerCloseActionText="Close"
        >
          <BookingsSectionTitle
            style={{ marginBottom: "10px", marginTop: "15px" }}
          >
            <span>Photo Information</span>
          </BookingsSectionTitle>
          <Form form={imageForm}>
            <StyledGridRow gutter={16}>
              <StyledGridCol lg={8}>
                <FormItem label="Image Type" name="imgType">
                  <Select
                    options={getOptionsFromRefList("Image_Type")}
                    getPopupContainer={(trigger) => trigger.parentNode}
                    disabled={!bookingsFieldsEnabled}
                  />
                </FormItem>
              </StyledGridCol>
              <StyledGridCol lg={8}>
                <FormItem label="Description" name="description">
                  <TextField id="description" disabled={!bookingsFieldsEnabled} />
                </FormItem>
              </StyledGridCol>
            </StyledGridRow>
            <StyledGridRow gutter={16}>
              <StyledGridCol lg={16}>
                <FileUploader
                disabled={!bookingsFieldsEnabled}
                  browseFileType="image"
                  acceptImageFormats="image/png,image/jpeg,image/jpg"
                  // canvasMaxHeight="500px"
                  allowMultiple={false}
                  onUpload={handleFileUpload}
                  imageUrlFromParent={
                    editingPhoto
                      ? PHOTOS_BASE_URL +
                        getFinalPath(editingPhoto.fullSizePath)
                      : ""
                  }
                />
              </StyledGridCol>
            </StyledGridRow>
          </Form>
        </Modal>

        {isChainCustodyReport && (
          <CommonReportModal
            show={isChainCustodyReport}
            onHide={() => setIsChainCustodyReport(false)}
            reportData={reportTableData}
          />
        )}
      </>
    );
  }
);

export default PropertyModal;
